import { CONFIG } from 'config/config';
import { UiWrapper } from '@coinscrap/webapp-core';


UiWrapper.defineComponent('inputSlider', {
	styles: {
		default: {
			railComponent: {
				height: 5,
				backgroundColor: CONFIG.colors.grey,
				borderRadius: 15,
			},
			trackComponent: {
				height: 5,
				backgroundColor: CONFIG.colors.success,
				borderRadius: 15,
			},
			thumbComponent: {
				width: 42,
				height: 42,
				marginTop: -21,
				color: CONFIG.colors.white,
				backgroundColor: CONFIG.colors.white,
				borderWidth: 18,
				borderColor: CONFIG.colors.success,
				borderStyle: 'solid',
			},
		},

		...CONFIG.commonStyles.styles,
	},
});
